export default "__VITE_ASSET__B5oZd75Y__"